import React from 'react';
import './App.scss';
import { RouterProvider, createBrowserRouter, Navigate } from 'react-router-dom';
import * as PATHS from './constants/paths';

import ErrorPage from './pages/ErrorPage';
import HomeLayout from './pages/home/Root';
import HomeLanding from './pages/home/Landing';
import TermsOfService from './pages/home/TermsOfService';
import PrivacyPolicy from './pages/home/PrivacyPolicy';

const router = createBrowserRouter([
  {
    errorElement: <ErrorPage />,
    children: [
      {
        path: PATHS.HOME,
        element: <HomeLayout />,
        children: [
          {
            index: true,
            element: <HomeLanding />
          },
          {
            path: 'terms-of-service',
            element: <TermsOfService />
          },
          {
            path: 'privacy-policy',
            element: <PrivacyPolicy />
          }
        ]
      },

      // The application backend has been retired. Any legacy app/auth/admin
      // route now simply redirects to the static landing page.
      {
        path: '*',
        element: <Navigate to="/" replace />
      }
    ]
  }
]);

function App() {
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
